import React from "react";
import styled from "styled-components";
import { tombac } from "../../shared/tombac";
import { TomTomLogo } from "../Symbols/TomTomLogo";
export function NavbarLogo(_ref) {
  let {
    breakpoint = 768,
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement(Logo, {
    breakpoint: breakpoint
  }), title && /*#__PURE__*/React.createElement(Title, null, title));
}
const Container = styled.div.withConfig({
  displayName: "NavbarLogo__Container"
})(["all:initial;align-items:center;align-self:center;display:flex;padding:", ";a&,button&{cursor:pointer;}@media (min-width:", "){padding:", ";}@media (min-width:", "){padding:", ";}"], tombac.space(0, 3), tombac.unit(960), tombac.space(0, 5), tombac.unit(1280), tombac.space(0, 10));
const Logo = styled(TomTomLogo).withConfig({
  displayName: "NavbarLogo__Logo"
})(["height:", ";@media (max-width:", "){height:", ";}"], tombac.unit(24), _ref2 => {
  let {
    breakpoint
  } = _ref2;
  return tombac.unit(breakpoint);
}, tombac.unit(18));
const Title = styled.span.withConfig({
  displayName: "NavbarLogo__Title"
})(["all:initial;align-items:center;border-left:", ";cursor:inherit;display:flex;height:", ";margin-left:", ";padding-left:", ";", ""], tombac.parse("1u solid --neutral-400"), tombac.unit(28), tombac.space(3), tombac.space(3), tombac.text());
//# sourceMappingURL=NavbarLogo.js.map